<template>
  <div class="project-tabs">
    <router-link
      :to="{ path: `/project-overview` }"
      class="nav-item overview col-6"
      :class="{ active: !active }"
      target="_self"
    >
      <span class="text-center">{{ $t("project.label_project_resource_situation_chart") }}</span>
    </router-link>
    <router-link
      :to="{ path: `/projects` }"
      class="nav-item project col-6"
      :class="{ active }"
      target="_self"
    >
      <span>{{ $t("project.label_project_list") }}</span>
    </router-link>
  </div>
</template>

<script>

export default {
  name: "Project-Layout",
  computed: {
    active () {
      return this.$route.name === 'projects'
    }
  },
  async created() {
  }
};
</script>

<style lang="scss" scoped>
.project-tabs {
  margin-bottom: 10px;
  margin-top: 10px;
  border-bottom: 0;
  flex-direction: inherit;
  font-size: 1rem;
  background-color: #EEEEEE;
  border-radius: 10px;
  max-width: 310px;
  margin-left: 32px;
  padding: 2px 0;
  display: flex;
}

.nav-item {
  color: #858585;
  cursor: pointer;
  padding: 0px;
  text-decoration: none;
  &.active {
    margin-left: 2px;
    span {
      color: #032641;
      display: inline-block;
      font-weight: bold;
      background-color: #FFFFFF;
      border-radius: 10px;
    }
  }
}

.nav-item span {
  width: 100%;
}

.nav-item.overview span {
  padding: 8px 11px 8px 13px;
}

.nav-item.overview {
  display: flex;
}

.nav-item.project {
  display: flex;
}

.nav-item.project span {
  padding: 8px 13px 8px 11px;
}

.nav-item.active.project span {
  padding: 8px 11px 8px 11px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.14);
}

.nav-item.active.overview span {
  padding: 8px 11px 8px 11px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.14);
}
</style>
